export default __webpack_public_path__ + "static/media/fastlane_detail4.395f54a9.jpg";